import { Prop, Vue } from 'vue-property-decorator'
import DataTableBase from '@/shared/classes/components/data-table/data-table'

export default class AbstractGroupComponent extends Vue {
  @Prop() table!: DataTableBase
  @Prop() items!: any[]
  @Prop() group!: any
}